import './PageHeader.css'
import { Col, Row } from 'react-bootstrap'


interface IProps {
  title: string,
  headerActionUrl?: string | null,
  description?: string | null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

const PageHeader = ({ children, title, headerActionUrl, buttonPermission, description }: IProps) => {

  const permission = buttonPermission

  return (
    <div>
      <Row>
        <Col md={6} style={{ alignSelf: 'center' }}>

          {headerActionUrl && permission
            ? <div className='d-flex'>
              <h3 className='text-h3-non-responsive'>{title}</h3>
              <div className='ms-2'>
              </div>
            </div>
            : <h3>{title}</h3>
          }

          {description
            ? <p className='font-lg mb-0'>{description}</p>
            : <></>
          }

        </Col>
        {children &&
          <Col md={6}>
            <div className='text-md-end'>
              {children}
            </div>
          </Col>
        }
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
    </div>
  )
}

export default PageHeader